var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShopping = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Shopping-Bag-Side--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Shopping Bag Side Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 6a1.93 1.93 0 0 0 -1.91 -2h-1.84a0.25 0.25 0 0 1 -0.25 -0.25V3a3 3 0 0 0 -3 -3h-3a3 3 0 0 0 -3 3v0.75a0.25 0.25 0 0 1 -0.25 0.25h-2a0.25 0.25 0 0 1 -0.25 -0.25V3a1 1 0 0 1 1 -1 1 1 0 0 0 0 -2 3 3 0 0 0 -3 3v0.75a0.25 0.25 0 0 1 -0.25 0.25H3.5a2 2 0 0 0 -2.07 1.86L0 22.05A2 2 0 0 0 2.07 24h20A1.94 1.94 0 0 0 24 22ZM12 3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v0.75a0.25 0.25 0 0 1 -0.25 0.25h-4.5a0.25 0.25 0 0 1 -0.25 -0.25ZM2.56 22a0.5 0.5 0 0 1 -0.5 -0.54l1.4 -15A0.5 0.5 0 0 1 4 6h2.58a0.5 0.5 0 0 1 0.5 0.47l0.83 15a0.48 0.48 0 0 1 -0.5 0.52Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShopping);
export default ForwardRef;